export default function RankingSection() {
  const rankings = [
    { rank: 1, title: '《庆余年2》', score: '9.3', type: '国产剧', trend: 'up', change: '+2' },
    { rank: 2, title: '《黑暗荣耀》', score: '9.1', type: '韩剧', trend: 'stable', change: '—' },
    { rank: 3, title: '《繁花》', score: '8.9', type: '国产剧', trend: 'up', change: '+1' },
    { rank: 4, title: '《流浪地球3》', score: '8.8', type: '电影', trend: 'new', change: 'NEW' },
    { rank: 5, title: '《咒术回战S2》', score: '8.7', type: '动漫', trend: 'down', change: '-1' },
  ];

  const getRankColor = (rank: number) => {
    if (rank === 1) return 'bg-accent-500 text-background-50';
    if (rank === 2) return 'bg-secondary-400 text-background-50';
    if (rank === 3) return 'bg-primary-500/60 text-background-50';
    return 'bg-background-300 text-foreground-400';
  };

  const getTrendIcon = (trend: string) => {
    if (trend === 'up') return 'ri-arrow-up-line text-emerald-400';
    if (trend === 'down') return 'ri-arrow-down-line text-red-400';
    if (trend === 'new') return 'ri-sparkling-line text-accent-500';
    return 'ri-subtract-line text-foreground-500';
  };

  const getChangeClass = (trend: string) => {
    if (trend === 'up') return 'text-emerald-400';
    if (trend === 'down') return 'text-red-400';
    if (trend === 'new') return 'text-accent-500';
    return 'text-foreground-500';
  };

  return (
    <section id="ranking" className="py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-3xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-50 mb-3" style={{ fontFamily: 'var(--font-heading)' }}>
            热播榜单
          </h2>
          <p className="text-sm text-foreground-500">实时热度排行，发现大家都在看的好内容</p>
        </div>

        <div className="space-y-3">
          {rankings.map((item) => (
            <div
              key={item.rank}
              className="flex items-center gap-4 p-4 bg-background-50 rounded-xl border border-background-200/50 cursor-pointer hover:border-primary-500/20 transition-all duration-200"
            >
              <div
                className={`w-9 h-9 rounded-lg flex items-center justify-center text-sm font-bold shrink-0 ${getRankColor(item.rank)}`}
                style={{ fontFamily: 'var(--font-heading)' }}
              >
                {item.rank}
              </div>
              <div className="flex-1 min-w-0">
                <div className="text-sm font-semibold text-foreground-100 truncate">{item.title}</div>
                <div className="text-xs text-foreground-500 mt-0.5">{item.type}</div>
              </div>
              <div className="flex items-center gap-3 shrink-0">
                <span className="text-sm font-bold text-accent-500 whitespace-nowrap" style={{ fontFamily: 'var(--font-heading)' }}>
                  {item.score}
                </span>
                <span className={`flex items-center gap-0.5 text-xs whitespace-nowrap ${getChangeClass(item.trend)}`}>
                  <i className={getTrendIcon(item.trend) + ' text-xs'}></i>
                  {item.change}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}